/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { UnifiedCollectionType } from 'client-code/previews';

import { TIVO_SERVICES } from '../../../config';
import { ImageAssetsService } from '../../../core/infrastructure';
import { ServicesClientImpl } from '../../../core/interactors';
import { TUnifiedCollectionPreview } from '../../../core/types';
import { PreviewComponentAssets } from '../../../core/usecases';
import { ActionButton, ContentDescription, ContentTitle, Divider, ShowcaseBanner } from '../ui-kit';
import { InfoCardProps } from './InfoCardProps';

const TeamAndLeagueInfoCard: FunctionComponent<InfoCardProps> = ({
    metadata,
    isActionMode,
    userActions,
    highlight,
}) => {
    const oPreviewAssets = new PreviewComponentAssets();
    const {
        unifiedCollectionType,
        title = '',
        description = oPreviewAssets.getStringAssestById(
            PreviewComponentAssets.StringAssets.DESCRIPTION_NOT_AVAILABLE,
        ),
        postfixTitle = '',
        unifiedCollectionId = '',
    } = metadata as TUnifiedCollectionPreview;

    const isNotTeamOrLeague =
        unifiedCollectionType !== UnifiedCollectionType.TeamPreview &&
        unifiedCollectionType !== UnifiedCollectionType.LeaguePreview;
    if (isNotTeamOrLeague) return null;

    const assetService = new ImageAssetsService({
        imageHostUrl: ServicesClientImpl.servicesBaseUrls[TIVO_SERVICES.ImageHost],
    });

    let url: string = assetService.getShowcaseBannerImageUrlForTeam(unifiedCollectionId);
    if (unifiedCollectionType === UnifiedCollectionType.LeaguePreview) {
        url = assetService.getShowcaseBannerImageUrlForLeague(unifiedCollectionId);
    }

    const drawInfoCard = () => {
        return (
            <div className="info-card-container">
                {/* <div className="info-card metadata-only"> 
                to show metadata only in scroll mode */}
                <div className="info-card">
                    <div className="info-card-header">
                        <div className="left-nav-arrow"></div>
                        {/* <div className="showcase-banner-metadata">
                        to switch between banner with metadata view */}
                        <div className="showcase-banner-metadata banner-only">
                            <ShowcaseBanner bannerUrl={url} size="contain" fallbackText={title} />
                        </div>
                        <div className="right-nav-arrow"></div>
                    </div>
                    <div className="info-card-body">
                        <ContentTitle
                            title={title}
                            postfixTitle={postfixTitle}
                            showType={unifiedCollectionType}
                        />
                        <ContentDescription description={description} />
                    </div>
                    <div className="info-card-footer">
                        <Divider />
                        {!isActionMode && <ActionButton type="options" highlighted={true} />}
                        {isActionMode &&
                            (userActions.length > 0 ? (
                                userActions.map((userAction, idx) => (
                                    <ActionButton
                                        key={userAction.id}
                                        highlighted={idx === highlight}
                                    >
                                        {userAction.text}
                                    </ActionButton>
                                ))
                            ) : (
                                <ActionButton type="info" highlighted={true} />
                            ))}
                    </div>
                </div>
            </div>
        );
    };

    return <React.Fragment>{drawInfoCard()}</React.Fragment>;
};

export default TeamAndLeagueInfoCard;
